import {BeneficiaryLink} from '../beneficiaries/beneficiary-link';
import {Dropdown} from './dropdown';

const BENEFICIARY_LINK_OPTIONS_FR: Dropdown<BeneficiaryLink>[] = [
  {name: 'Conjoint', value: BeneficiaryLink.PARTNER},
  {name: 'Époux', value: BeneficiaryLink.HUSBAND},
  {name: 'Épouse', value: BeneficiaryLink.WIFE},
  {name: 'Père', value: BeneficiaryLink.FATHER},
  {name: 'Mère', value: BeneficiaryLink.MOTHER},
  {name: 'Frère', value: BeneficiaryLink.BROTHER},
  {name: 'Soeur', value: BeneficiaryLink.SISTER},
  {name: 'Fils', value: BeneficiaryLink.SON},
  {name: 'Fille', value: BeneficiaryLink.DAUGHTER},
  {name: 'Petit fils', value: BeneficiaryLink.GRAND_SON},
  {name: 'Petite fille', value: BeneficiaryLink.GRAND_DAUGHTER},
  {name: 'Grand-Père', value: BeneficiaryLink.GRAND_FATHER},
  {name: 'Grand-Mère', value: BeneficiaryLink.GRAND_MOTHER},
  {name: 'Neveu', value: BeneficiaryLink.NEPHEW},
  {name: 'Nièce', value: BeneficiaryLink.NIECE},
  {name: 'Filleul', value: BeneficiaryLink.GODSON},
  {name: 'Filleulle', value: BeneficiaryLink.GODDAUGHTER},
  {name: 'Père des enfants', value: BeneficiaryLink.FATHER_OF_MY_CHILDREN},
  {name: 'Mère des enfants', value: BeneficiaryLink.MOTHER_OF_MY_CHILDREN},
  {name: 'Ami(e)', value: BeneficiaryLink.FRIEND},
  {name: 'Oncle', value: BeneficiaryLink.UNCLE},
  {name: 'Tante', value: BeneficiaryLink.AUNT},
];

const BENEFICIARY_LINK_OPTIONS_EN: Dropdown<BeneficiaryLink>[] = [
  {name: 'Partner', value: BeneficiaryLink.PARTNER},
  {name: 'Husband', value: BeneficiaryLink.HUSBAND},
  {name: 'Wife', value: BeneficiaryLink.WIFE},
  {name: 'Father', value: BeneficiaryLink.FATHER},
  {name: 'Mother', value: BeneficiaryLink.MOTHER},
  {name: 'Brother', value: BeneficiaryLink.BROTHER},
  {name: 'Sister', value: BeneficiaryLink.SISTER},
  {name: 'Son', value: BeneficiaryLink.SON},
  {name: 'Daughter', value: BeneficiaryLink.DAUGHTER},
  {name: 'Grandson', value: BeneficiaryLink.GRAND_SON},
  {name: 'Granddaughter', value: BeneficiaryLink.GRAND_DAUGHTER},
  {name: 'Grandfather', value: BeneficiaryLink.GRAND_FATHER},
  {name: 'Grandmother', value: BeneficiaryLink.GRAND_MOTHER},
  {name: 'Nephew', value: BeneficiaryLink.NEPHEW},
  {name: 'Niece', value: BeneficiaryLink.NIECE},
  {name: 'Godson', value: BeneficiaryLink.GODSON},
  {name: 'Goddaughter', value: BeneficiaryLink.GODDAUGHTER},
  {name: 'Father of my children', value: BeneficiaryLink.FATHER_OF_MY_CHILDREN},
  {name: 'Mother of my children', value: BeneficiaryLink.MOTHER_OF_MY_CHILDREN},
  {name: 'Friend', value: BeneficiaryLink.FRIEND},
  {name: 'Uncle', value: BeneficiaryLink.UNCLE},
  {name: 'Aunt', value: BeneficiaryLink.AUNT},
];

export const BENEFICIARY_LINK_OPTIONS = {
  en: BENEFICIARY_LINK_OPTIONS_EN,
  fr: BENEFICIARY_LINK_OPTIONS_FR,
};
